/**
 * Pollo Wan 2.6：generation/wanx/wan-v2-6
 * 图生：input.image 必填（HTTPS URL），prompt、negativePrompt、length(2-15)、resolution(720P|1080P)、seed、audioUrl、multiClip、generateAudio
 * 文生：input.prompt 必填，aspectRatio(1:1|4:3|3:4|16:9|9:16)，其余同上
 */
import { isUrl } from './utils'

var RES_MAP = { '480p': '1080P', '480P': '1080P', '720p': '720P', '720P': '720P', '1080p': '1080P', '1080P': '1080P' }
var ASPECT_MAP = { '1:1': '1:1', '4:3': '4:3', '3:4': '3:4', '16:9': '16:9', '9:16': '9:16' }

function normalizeResolution(v) {
  if (!v) return '1080P'
  var key = String(v).trim()
  return RES_MAP[key] || '1080P'
}

function normalizeAspectRatio(v) {
  if (!v) return '16:9'
  var key = String(v).trim().replace(/：/g, ':')
  return ASPECT_MAP[key] || '16:9'
}

function clampLength(n) {
  var num = parseInt(n, 10)
  if (isNaN(num)) return 5
  return Math.min(15, Math.max(2, num))
}

export function buildBody(params) {
  var hasImage = isUrl(params.referenceImage)
  var input = {
    prompt: (params.prompt || '').trim().slice(0, 2000),
    negativePrompt: (params.negativePrompt || '').trim().slice(0, 500) || undefined,
    length: clampLength(params.videoDuration || params.length || 5),
    resolution: normalizeResolution(params.videoRes || params.resolution),
    multiClip: params.multiClip === true,
    generateAudio: params.generateAudio === true
  }
  var seed = params.seed != null && params.seed !== '' && params.seed !== -1 ? parseInt(params.seed, 10) : null
  if (seed != null && !isNaN(seed) && seed <= 2147483647) input.seed = seed
  if (params.audioUrl && isUrl(params.audioUrl)) input.audioUrl = params.audioUrl.trim()
  if (hasImage) {
    input.image = params.referenceImage.trim()
  } else {
    input.aspectRatio = normalizeAspectRatio(params.aspectRatio)
  }
  var body = { input: input }
  if (params.webhookUrl && isUrl(params.webhookUrl)) body.webhookUrl = params.webhookUrl
  return body
}
